<template>
  <v-card :loading="loading">
    <v-toolbar dense elevation="1">
      <v-spacer />
      <v-toolbar-title>
        Device Snapshot
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="cancel" v-on="on">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>閉じる</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="auto">
            {{ timestamp }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-img
              :src="image"
              width="640"
              height="480"
              class="elevation-2"
              v-ripple
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="success"
        outlined
        @click="request"
        :disabled="!deviceOnline"
      >
        <v-icon left>mdi-download</v-icon>
        Request
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { functions } from '@/config/firebase'
import { fmtToNow } from '@/plugins/datefns'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DeviceSnapshotCard',
  props: {
    device: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      snapshot: 'devices/snapshots/getSnapshot'
    }),
    deviceOnline() {
      if (this.device) {
        return this.device.online
      }
      return false
    },
    timestamp() {
      if (this.snapshot) {
        if (this.snapshot.timestamp) {
          return fmtToNow(this.snapshot.timestamp.toDate())
        }
      }
      return '--'
    },
    image() {
      if (this.snapshot) {
        return this.snapshot.image
      }
      return ''
    }
  },
  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack',

      bindDeviceSnapshotRef: 'devices/snapshots/bindRef'
    }),
    request() {
      this.loading = true
      const request = functions.httpsCallable('device-SendCommand')
      request({ deviceId: this.device.id, payload: { command: 'snapshot' } })
        .then(result => {
          if (result.data.success) {
            this.showSnack({ message: result.data.message })
          } else {
            this.showSnack({ message: result.data.message, color: 'error' })
          }
        })
        .catch(error => {
          this.showSnack({ message: error, color: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getSnapshot() {
      if (this.device.id) {
        this.loading = true
        this.bindDeviceSnapshotRef(this.device.id).then(() => {
          this.loading = false
        })
      }
    },
    cancel() {
      this.$emit('cancel')
    }
  },
  watch: {
    device() {
      this.getSnapshot()
    }
  },
  mounted() {
    this.getSnapshot()
  }
}
</script>

<style scoped></style>
